import styled from "styled-components";

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const FormBody = styled.div`
  max-height: 70vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;

export const ExplanationBox = styled.div`
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 12px;
  margin-top: 1rem;
`;

export const ExplanationText = styled.p`
  font-family: "Lato";
  font-size: 0.875rem;
  font-style: italic;
  color: #474747;
  line-height: 1.4;
  margin: 0;
  padding: 0;
  white-space: pre-line;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gridGap ?? "1.25rem"};
  margin-bottom: ${(props) => props.marginBottom ?? "10px"};
  margin-top: ${(props) => props.marginTop ?? "10px"};
`;

export const FieldLabel = styled.label`
  display: block;
  vertical-align: text-top;
  margin-bottom: 7px;
  font-weight: 700;
  font-size: 1rem;
  font-family: "Lato";
  color: #1bace4;
  line-height: 1;
  text-transform: initial;
`;

export const RequiredStar = styled.span`
  color: red;
  margin-left: 2px;
`;

export const DatePickerWrapper = styled.div`
  input {
    background-color: ${(props) => (props.disabled ? "#f6f6f6" : "white")};
    font-family: "Lato";
    font-size: 16px;
    height: auto;
    width: 100%;
    border-radius: 5px;
    padding: 7px 5px 7px 10px;
    border: 1px solid ${(props) => (props.hasError ? "red" : "#474747")};
    box-sizing: border-box;
  }
`;

export const CheckboxRow = styled.div`
  margin-top: 5px;
`;

export const SitesSection = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const SitesHeader = styled.div`
  background-color: #008395;
  color: #fff;
  font-family: "Lato";
  font-size: 1rem;
  font-weight: 700;
  padding: 8px 12px;
  border-radius: 4px 4px 0 0;
`;

export const SitesList = styled.div`
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 4px 4px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background-color: #f6f6f6;
`;

export const SiteCard = styled.div`
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px 12px;
  background-color: #fff;
`;

export const SiteTitle = styled.div`
  color: #084987;
  font-family: "Lato";
  font-size: 0.875rem;
  font-weight: 700;
`;

export const SiteClient = styled.div`
  color: #767676;
  font-family: "Lato";
  font-size: 0.875rem;
  font-style: italic;
  margin-top: 2px;
`;

export const GenerationStartedMessage = styled.p`
  font-family: "Lato";
  font-size: 0.875rem;
  color: #767676;
  font-style: italic;
  line-height: 1.4;
  margin: 1rem 0;
  padding: 0;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 2rem;
  color: #767676;
  font-family: "Lato";
  font-size: 0.875rem;
  font-style: italic;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
  gap: 0.5rem;
`;
